import { AssetsService } from "app/services/AssetsService";

import * as SC from "./styledComponents";

const AI_LOADING_GIF = "/images/ai-tagging/copilotloader.webp";

type AILoaderProps = {
    title: string;
    subTitle?: string;
    classname?: string;
};

export const AILoader = ({ title, subTitle, classname }: AILoaderProps) => {
    return (
        <SC.LoaderWrapper className={classname}>
            <SC.LoaderGif src={AssetsService.assetUrl(AI_LOADING_GIF)} alt={title} />
            <SC.LoaderTextWrapper>
                <SC.LoaderTitle>{title}</SC.LoaderTitle>
                {subTitle ? <SC.LoaderSubTitle>{subTitle}</SC.LoaderSubTitle> : null}
            </SC.LoaderTextWrapper>
        </SC.LoaderWrapper>
    );
};
